<script setup lang="ts">
import type { CommandItemBaseProps } from "./types";
import { AtSignIcon } from "lucide-vue-next";
import SuggestionListItem from "../suggestions/SuggestionListItem.vue";

const props = defineProps<CommandItemBaseProps>();

function run() {
  props.editor
    .chain()
    .focus()
    .deleteRange(props.range)
    .startMention()
    .run();
}

defineExpose({ run });
</script>

<template>
  <SuggestionListItem
    :icon="AtSignIcon"
    shortcut="@"
    @click="run"
    @keydown.enter="run"
  >
    Mention
  </SuggestionListItem>
</template>
